import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import styles from './Table.module.css'

const Row = ({
  children,
  className,
  primary,
  secondary,
  tertiary,
  primaryBorder,
  secondaryBorder,
  small,
  medium,
  big,
  skipNavigation,
  testId,
}) => {
  const extraClasses = {
    [styles.primary]: primary,
    [styles.secondary]: secondary,
    [styles.tertiary]: tertiary,
    [styles.primaryBorder]: primaryBorder,
    [styles.secondaryBorder]: secondaryBorder,
    [styles.small]: small,
    [styles.medium]: medium,
    [styles.big]: big,
  }

  return (
    <tr
      className={classNames(styles.Row, className, extraClasses)}
      data-skip-navigation={skipNavigation || null}
      data-testid={testId}
    >
      {children}
    </tr>
  )
}

Row.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  primaryBorder: PropTypes.bool,
  secondaryBorder: PropTypes.bool,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  big: PropTypes.bool,
  skipNavigation: PropTypes.bool,
  /* Forwarded as data-testid to the <tr>. Use business identity, never the index */
  testId: PropTypes.string,
}

Row.defaultProps = {
  children: null,
  className: '',
  primary: true,
  secondary: false,
  tertiary: false,
  primaryBorder: true,
  secondaryBorder: false,
  small: false,
  medium: false,
  big: false,
  skipNavigation: false,
  testId: undefined,
}

export default Row
